import { render, staticRenderFns } from "./projectList.vue?vue&type=template&id=c47d8244&scoped=true&"
import script from "./projectList.vue?vue&type=script&lang=js&"
export * from "./projectList.vue?vue&type=script&lang=js&"
import style0 from "./projectList.vue?vue&type=style&index=0&id=c47d8244&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47d8244",
  null
  
)

export default component.exports